/* eslint-disable */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, SelectChangeEvent } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useHistory } from 'react-router-dom';
import LogoImg from 'assets/images/logo.svg';
import { RootState } from 'store/store';
import { callsActions } from 'store/calls';
import { translate } from 'localizations';
import { removeAuthToken } from 'store/user/auth.thunks';
import { useAppSelector } from 'hooks/redux';
import { searchSlice } from 'store';
import { updateUser } from 'store/user/user.slice';
import { getLang } from 'store/lang/lang.slice';
import { LabelSelect, OldInterfaceLink, Tooltip } from 'components/common';
import { OptionType } from 'components/common/Selects/MultiValueSelect/multiValuesSelect';
import BellSelect from 'components/RealtimeTasks/BellSelect';
import { PersonSvg } from 'components/Icons/PersonSvg';
import { getAllReports } from 'store/reports/actions';
import { getTokens } from '../../../utils/tokens';
import { useStyles } from './Header.jss';
import ToggleButtons from '../ToggleButtons/ToggleButtons';
import useToggleButtons from './hooks/useToggleButtons';
import { useSnackbar } from 'notistack';
import { getBaseCallsData, getBaseCallsDataReports } from 'store/calls/actions';
import { exportsActions } from 'pages/Calls/components/CallsHeader/const';
import { getActionFiles, getTaskStatus, tasksSlice, TaskType } from 'store/tasks/tasks.slice';
import { createSnackbarOptions } from '../Snackbar/Snackbar';
import { useCurrentUser } from 'hooks';

const Header: React.FC = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	const language = useAppSelector((state: RootState) => state.lang.language);
	const user = useAppSelector((state) => state.user.user);
	const childUser = useAppSelector((state) => state.user.childUser);
	const isAuth = useAppSelector((state) => state.user.isAuth);
	const pathArray = history.location.pathname.split('/');
	const path = pathArray[3];
	const accessRights = useAppSelector((state) => state.user.accessRights);

	const userPathName = childUser ? childUser.id : user ? user.id : '_';

	const toggleButtons = useToggleButtons(language);

	const tasks = useAppSelector((state) => state.tasks.realtimeTasks);
	const { enqueueSnackbar } = useSnackbar();
	const sort = useAppSelector((state: RootState) => state.calls.sort);
	const mode = useAppSelector((state) => state.search.calls.mode);
	const search_filter_hash = useAppSelector((state) => state.search.reports.search_filter_hash);

	const currentUser = useCurrentUser();
	// роутинг
	const [alignment, setAlignment] = React.useState('');
	const handleRouteChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
		setAlignment(newAlignment);
	};

	const { token } = getTokens();

	useEffect(() => {
		const hasReports = !['admin', 'manager'].includes(currentUser?.role as string) && accessRights?.report;
		if (hasReports) {
			const fetchAllReports = async () => {
				await dispatch(getAllReports());
			};
			fetchAllReports();
		}
	}, [dispatch]);

	useEffect(() => {
		const pageSetter = (location: any) => {
			const page = location.pathname.split('/')[3];
			if (page === 'dictionaries' || page === 'checklists') setAlignment('tags');
			if (page === 'report') setAlignment('reports');
			else setAlignment(page);
		};
		history.listen((location) => {
			pageSetter(location);
		});
		pageSetter(history.location);
	}, [history.location]);

	// лэнг ченджер
	async function handleLangChange(event: SelectChangeEvent) {
		if (user) {
			const currentLang = event.target.value; // @ts-ignore
			await dispatch(updateUser({ id: childUser ? childUser.id : user.id, language: currentLang }));
			await dispatch(getLang(currentLang));
			history.push(`/${currentLang}/${childUser ? childUser.id : user.id}/${path}`);
			window.location.reload();
		}
	}

	const logout = () => {
		dispatch(removeAuthToken());
		dispatch(callsActions.setCalls(false));
		dispatch(searchSlice.actions.searchReset());
		history.push(`/${language}/auth`);
		window.location.reload();
	};

	const login = () => {
		history.push(`/${language}/auth`);
	};

	const onLogoClick = (): void => {
		history.push(`/${language}/${userPathName}/calls`);
		window.location.reload();
	};

	// задачи
	const progressTasksForMode = async (task: TaskType) => {
		if (task.action && exportsActions.includes(task.action)) {
			// скачивание звонков (экспорт аудио, экспорт расшифровки, экспорт звонков)
			await dispatch(getActionFiles({ taskId: task.task_id, action: task.action }));
		} else {
			// все остальные действия
			if (mode === 'REPORTS') {
				// @ts-ignore
				await dispatch(getBaseCallsDataReports({ page: 1, hash: search_filter_hash }));

				// почему не обновляется звонок открытый
			} else {
				await dispatch(getBaseCallsData({ page: 1, sort: sort.sort, sortDesc: sort.sortDesc }));
			}
		}
	};

	const realTimeTasksHandler = (task: TaskType, index: number) => {
		if (!['SUCCESS', 'FAILURE'].includes(task.status) && !task.startProgress) {
			dispatch(tasksSlice.actions.replaceRealtimeTask({ task: { ...task, startProgress: true }, index }));

			const timer = setInterval(async () => {
				const taskData = await dispatch(getTaskStatus(task.task_id)); // @ts-ignore
				const newTask = taskData.payload;
				if (newTask) {
					dispatch(
						tasksSlice.actions.replaceRealtimeTask({
							task: { ...newTask, startProgress: true },
							index,
						}),
					);
				} else {
					clearInterval(timer);
					enqueueSnackbar(
						null,
						createSnackbarOptions({
							time: 2000,
							text: translate('taskCanceled', language),
							type: 'info',
						}),
					);
				}
				if (!['PROGRESS', 'PENDING'].includes(newTask.status)) {
					clearInterval(timer);
					progressTasksForMode(task);

					dispatch(tasksSlice.actions.removeRealtimeTask(index));
					enqueueSnackbar(
						null,
						createSnackbarOptions({
							time: 2000,
							text: translate('taskComplete', language),
							type: 'success',
						}),
					);
				}
			}, 2000);
		}
	};

	useEffect(() => {
		tasks.map((task, index) => {
			realTimeTasksHandler(task, index);
		});
	}, [tasks]);

	return (
		<div className={classes.headerWrapper}>
			<div className={classes.headerInner}>
				<div className={classes.headerLeftBlock}>
					{/* Логотип */}
					<div style={{ cursor: 'pointer' }} onClick={onLogoClick} className={classes.headerIconWrapper}>
						<img className={classes.headerIcon} height={55} src={LogoImg} alt="Imot.io" />
					</div>
					{/* Навигация */}
					{token && (
						<ToggleButtons
							alignment={alignment}
							handleRouteChange={handleRouteChange}
							toggleButtons={toggleButtons}
							language={language}
							userPathName={userPathName}
							accessRights={accessRights}
						/>
					)}
				</div>
				<div className={classes.headerRightBlock}>
					<div style={{ marginTop: '2px', display: 'flex', alignItems: 'center' }}>
						{token && (
							<>
								{/* история задач */}
								<div style={{ marginLeft: '5px' }}>
									<BellSelect />
								</div>
								{/* старый интерфейс */}
								<div style={{ marginLeft: '5px' }}>
									<OldInterfaceLink />
								</div>
							</>
						)}
						{/* логин/логаут */}
						<div style={{ marginLeft: '5px' }}>
							{isAuth ? (
								<Tooltip title={translate('profile', language)} placement="bottom">
									<div style={{ marginRight: '10px', cursor: 'pointer' }}>
										<LabelSelect
											value={[]}
											options={[
												{ label: translate('profile', language), value: 'profile' },
												{ label: translate('logout', language), value: 'logout' },
											]}
											notPlusMinus
											valueHandler={(values: OptionType[]) => {
												if (values[0].value === 'logout') logout();
												else if (values[0].value === 'profile')
													history.push(
														`/${language}/${
															user ? user.id : '_'
														}/settings?settingsParam=usersProfile`,
													);
											}}
											customLabel={
												<div style={{ display: 'flex', alignItems: 'center' }}>
													<IconButton size="small">
														<PersonSvg fill="#A3AEBE" />
													</IconButton>
												</div>
											}
										/>
									</div>
								</Tooltip>
							) : (
								<Tooltip title={translate('logout', language)} placement="bottom">
									<IconButton onClick={logout} size="small">
										<PersonSvg fill="#A3AEBE" />
									</IconButton>
								</Tooltip>
							)}
						</div>
						{/* смена языка */}
						<div>
							<Select
								MenuProps={{ disableScrollLock: true }}
								className={classes.langHandler}
								variant="standard"
								value={language}
								onChange={handleLangChange}
							>
								<MenuItem className={classes.langHandlerItem} value="ru">
									RU
								</MenuItem>
								<MenuItem className={classes.langHandlerItem} value="en">
									EN
								</MenuItem>
							</Select>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
